import {
  VideoEditConfig,
  ExportVideoRequest,
  ExportVideoResponse,
  ExportStatusResponse,
  FontRenderItem,
} from '@packages/global';
import { httpClient } from '../httpClient';

export const videoExportApi = {
  // 保存编辑配置
  saveEditConfig: async (episodeId: string, editConfig: VideoEditConfig): Promise<VideoEditConfig | null> => {
    return httpClient.put<VideoEditConfig | null>(`/user/videoExport/${episodeId}/edit-config`, {
      editConfig
    });
  },

  // 获取编辑配置
  getEditConfig: async (episodeId: string): Promise<VideoEditConfig | null> => {
    return httpClient.get<VideoEditConfig | null>(`/user/videoExport/${episodeId}/edit-config`);
  },

  // 获取可用字幕字体
  getAvailableFonts: async (episodeId: string): Promise<FontRenderItem[]> => {
    return httpClient.get<FontRenderItem[]>(`/user/videoExport/${episodeId}/fonts`);
  },

  // 导出视频
  exportVideo: async (episodeId: string, exportRequest: ExportVideoRequest = {}): Promise<ExportVideoResponse> => {
    return httpClient.post<ExportVideoResponse>(`/user/videoExport/${episodeId}/export`, exportRequest);
  },

  // 获取导出状态
  getExportStatus: async (episodeId: string, jobId: string): Promise<ExportStatusResponse> => {
    return httpClient.get<ExportStatusResponse>(`/user/videoExport/${episodeId}/export/${jobId}/status`);
  },

  // 获取导出历史
  getExportHistory: async (episodeId: string) => {
    return httpClient.get(`/user/videoExport/${episodeId}/export/history`);
  }
};
